import { useCommonModal } from 'hooks/useCommonModal';
import React, { useEffect, useRef, useState, useCallback } from 'react';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import { GButtonBox, GPopupTitle } from 'components/layouts/GLayoutBox';
import { DialogTitleItem } from 'components/layouts/GModalPopup';
import { useTranslation } from 'react-i18next';
import { GButton } from 'components/atom/button';
import Save from 'components/asset/images/Confirm.svg';
import ModalLayout from 'components/layouts/ModalLayout';
import { GbasicTable, GbasicTableWrap } from 'components/tables/GTable';
import { GLabelAtom } from 'components/atom/label';
import { SubTitleBtnArea } from 'components/organism/SubTitleBtnArea';
import SubTitleBox from 'components/molecule/SubTitleBox';
import styled from '@emotion/styled';
import InputField from 'components/atom/input';
import { GCodeSelect } from 'components/selects/GCodeSelect';
import { CommonCode } from 'models/admin/CommonCode';
import FileUploadVars from 'components/vars/common/FileUploadVars';
import { getJwtCommonCodes } from 'apis/vars/common/Common';
import { FileSaveResponse, FileSaveResult } from 'models/admin/FileInfo';
import useFrgnRegist from './hooks/useFrgnRegist';
import { useLoading } from 'components/process/Loading';
import { useMessageBar } from 'components/process/MessageBar';
import { ForeignAccountVO } from 'models/vars/account/ForeignAccountVO';
import {
  copyForeignAccount,
  getForeignAccount,
  getDupleCopyForeignAccount,
} from 'apis/vars/account/ForeignAccount';
import { GridBox, GridItem } from 'components/organism/GridBox';
import { getAccnValidInfo } from 'apis/vars/account/CommonAccount';
import { AccountValidVO } from 'models/vars/account/AccountValidVO';
import { GLabelAtomVars } from 'components/vars/common/GLabelAtomVars';
import Download from 'components/asset/images/Download.svg';
import usePifPrint from '../hooks/usePifPrint';
import { getCommonCodes } from 'apis/admin/CommonCode';
import { ValidationBox } from 'components/validation/ValidationBox';
import _ from 'lodash';
import FileDownloadVars from 'components/vars/common/FileDownloadVars';
import VarsAutoInput from 'components/vars/signup/VarsAutoInput';
import { Employee } from 'models/admin/Employee';
import { MemberEditVO } from '../../member/manage/MemberDetailPage';
import { modifyCheckVendorApi } from 'apis/vars/member/Member';
import useAccountRegistStore from 'stores/useAccountRegistStore';

type DmsChgFrgnAcntModalProps = {
  open: boolean;
  close: (param?: boolean) => void;
  save: (param?: boolean) => void;
  vendorInfo?: any;
  frgnAccount?: any;
  stdAccnCds?: any;
  node: any;
  isKrw: boolean;
};

interface AccnChgVO extends ForeignAccountVO {
  currCd?: string; //미사용
  ibanYn?: string;
  isDpstNmCert?: string; // 화면에서 사용
  isDpstNmCertRslt?: string;
}

interface MemberVO extends MemberEditVO {
  soprMgrEmpNo: string;
}

interface AccnFiles {
  fileId1?: string;
  fileId2?: string;
  fileId3?: string;
  // fileId4?: string;
  fileId5?: string;
}

const DmsCopyFrgnAcntModal = (props: DmsChgFrgnAcntModalProps) => {
  //
  const [bankNoTpCdList, setBankNoTpCdList] = useState<CommonCode[]>([]); //BANK_NO_TP_CD

  const [bankLoctCtryCdList, setBankLoctCtryCdList] = useState<CommonCode[]>([]); //BANK_LOCT_CTRY_CD

  const [copCdList, setCopCdList] = useState<CommonCode[]>([]); //COP_CD

  const [managerSrchModalOpen, setManagerSrchModalOpen] = useState<boolean>(false);

  const { setIsCopyAccount } = useAccountRegistStore();

  // 선택된 담당자 리스트
  const [selectedManagerData, setSelectedManagerData] = useState<Employee[]>([]);

  const [signUpFormData, setSignUpFormData] = useState<MemberVO>({
    ...props.vendorInfo,
    soprMgrCopCd: '',
    soprMgrEmal: '',
    soprMgrEmpNo: '',
    soprMgrNm: '',
  });

  const { t } = useTranslation();

  const t2 = t as (msgId: string, defVal: string) => string;

  const { openCommonModal } = useCommonModal();

  const { openMessageBar } = useMessageBar();

  const [dtlFrgnAccount, setDtlFrgnAccount] = useState<ForeignAccountVO>();

  const [wktDivsCdList, setWktDivsCdList] = useState<CommonCode[]>([]);

  const { openLoading } = useLoading();
  const { regSchema, regSchemaKrw, regSchemaDo } = useFrgnRegist();
  const files = {} as AccnFiles;

  const dmstFrgDivsCd = props.vendorInfo.dmstFrgDivsCd;

  const [chgAccnInfo, setChgAccnInfo] = useState<AccnChgVO>({
    ...dtlFrgnAccount,
    ...props.vendorInfo,
    isDpstNmCert: props.isKrw ? 'Y' : 'N',
    txCd: props.vendorInfo.copRegNo,
    copList: [props.vendorInfo.soprMgrCopCd],
    currCd: props.isKrw ? 'KRW' : dtlFrgnAccount?.currCd ?? 'USD',
    accnNoCertYn: 'N',
    addAtrValCtn06: 'N',
    ibanYn: props.frgnAccount.ibanCd ? 'IBAN' : 'Normal',
    wktDivsCd: 'N',
    bankKeyCd: '', //뱅크키 초기화
    isDpstNmCertRslt: 'N',
    bankCd: '', //0404 뱅크코드 초기화
  } as AccnChgVO);

  const [certFlag, setCertFlag] = useState<boolean>(false);

  // 예금주, 해외 은행 영어 입력 이외 법인들
  const [exceptCopCd, setExceptCopCd] = useState<string[]>([]);

  const [statCdList, setStatCdList] = useState<CommonCode[]>([]);

  const getExceptCopCdData = useCallback(() => {
    //
    getCommonCodes('EN_EXCEPT_COP_CD').then((result: CommonCode[]) => {
      const resList = result
        .filter((item) => 'Y' === item.useYn)
        .map((item) => item.cmnCd ?? '')
        .filter(Boolean);
      if (resList) setExceptCopCd(resList);
    });

    getCommonCodes('PROG_STAT_CD').then((result: CommonCode[]) => {
      const res = result.filter((item) => 'Y' === item.useYn);
      if (res) setStatCdList(res);
    });
  }, []);

  const fileDropzoneRef1 = useRef<any>();
  const fileDropzoneRef2 = useRef<any>();
  const fileDropzoneRef3 = useRef<any>();
  const fileDropzoneRef5 = useRef<any>();

  // PIF 출력폼
  const { handleClickPif, setBankInfo, setBasicVendorInfo } = usePifPrint();

  useEffect(() => {
    //
    setBasicVendorInfo(props.vendorInfo);
  }, []);

  useEffect(() => {
    setBankInfo(chgAccnInfo);
  }, [chgAccnInfo]);

  const handleClose = (result?: boolean) => {
    props.close(result);
  };

  const handleValidAccnClick = async () => {
    if (!chgAccnInfo.bankCd) {
      openCommonModal({
        modalType: 'alert',
        content: t('com.label.00729', '__SWIFT/BIC를 입력하세요.'),
      });
      return;
    }

    if (!chgAccnInfo.encAccnNo) {
      openCommonModal({
        modalType: 'alert',
        content: t('com.label.00448', '__계좌번호를 입력하세요.'),
      });

      return;
    }

    if (!chgAccnInfo.dpstNm) {
      openCommonModal({
        modalType: 'alert',
        content: t('com.label.00449', '__예금주를 입력하세요.'),
      });
      return;
    }

    if (!chgAccnInfo.currCd) {
      openCommonModal({
        modalType: 'alert',
        content: t('com.label.00450', '__통화를 입력하세요.'),
      });
      return;
    }

    const accnValidParam = {
      ZBNKY: chgAccnInfo.bankCd,
      ZBNKN: chgAccnInfo.encAccnNo,
      ZNME1: chgAccnInfo.dpstNm,
      WAERS: chgAccnInfo.currCd,
    } as AccountValidVO;

    openLoading(true);
    await getAccnValidInfo(accnValidParam)
      .then((resp) => {
        openLoading(false);
        if (resp.result == 'S') {
          setChgAccnInfo((prev) => {
            return {
              ...prev,
              addAtrValCtn06: 'Y', //예금주 확인 완료 여부
              addAtrValCtn08: resp.result, //예금주 인증처리 결과코드
              addAtrValCtn09: resp.e_ZNME1, //예금주 인증처리 결과내용
              addDpstNm: resp.e_ZNME1, //예금주 확인 필드
              isDpstNmCertRslt: 'Y',
            };
          });
          openMessageBar('success', t('com.label.00040', '__인증에 성공하였습니다.'));
        } else {
          if (!props.isKrw) {
            setChgAccnInfo((prev) => {
              return {
                ...prev,
                isDpstNmCertRslt: 'Y',
                addAtrValCtn08: resp.result ?? '', //예금주 인증처리 결과코드
                addAtrValCtn09: resp.e_ZNME1 ?? '', //예금주 인증처리 결과내용
                addDpstNm: resp.e_ZNME1 ?? '', //예금주 확인 필드
              };
            });
          }
          alert(resp.error_INFO);
        }
      })
      .catch((e) => {
        console.error('error', e);
        openLoading(false);
      });
  };

  function chkEnInput(): boolean {
    // props.vendorInfo.land1/ props.vendorInfo.soprMgrCopCd
    // 공통 코드에 영어외 입력 가능 법인들에 벤더코드 담당자의 법인이 속하면 체크 않아고 return
    const bool = exceptCopCd.includes(props.vendorInfo.soprMgrCopCd);
    if (bool || props.isKrw) return true; // 외국벤더이여도 원화선택시에는 적용 안되도록 추가
    const { dpstNm, bankNm } = chgAccnInfo;
    const hasDpstNmEnglish = /[a-zA-Z]/.test(dpstNm ?? '');
    const hasBankNmEnglish = /[a-zA-Z]/.test(bankNm ?? '');
    const specialChars = ['!', '@', '#', '$', '%', '^', '&', '*', '/', '[', ']', '{', '}', '，'];
    const forbiddenChars = new RegExp(`[${specialChars.join('\\')}]`, 'g');
    //
    if (!(hasDpstNmEnglish && !forbiddenChars.test(dpstNm ?? ''))) {
      //
      openCommonModal({
        modalType: 'alert',
        content: t(
          'com.label.mgt.onlyenEn.accountNm',
          '__Account Name 필드에는 영어만 입력이 가능합니다.'
        ),
      });
      return false;
    }
    if (dmstFrgDivsCd == 'DO') {
      const forbidden = /[äöüßÄÖÜ\uFF08\uFF09]/;
      if (!(hasBankNmEnglish && !forbidden.test(bankNm ?? ''))) {
        //
        openCommonModal({
          modalType: 'alert',
          content: t(
            'com.label.mgt.onlyenEn.bankNm',
            '__Bank Name 필드에는 영어만 입력이 가능합니다.'
          ),
        });
        return false;
      }
    } else {
      const forbidden = /!#$%^&*()=+{}[\]:;"'<>,?/\\|`~\uFF08\uFF09]/;
      if (!(hasBankNmEnglish && !forbidden.test(bankNm ?? ''))) {
        //
        openCommonModal({
          modalType: 'alert',
          content: t(
            'com.label.mgt.onlyenEn.bankNm',
            '__Bank Name 필드에는 영어만 입력이 가능합니다.'
          ),
        });
        return false;
      }
    }
    return true;
  }

  /**
   * Mypage와 같이 선택한 법인에 해당 Vendor ID가 존재하는지 체크
   */
  async function modifyCheckVendor() {
    //
    const bool = await modifyCheckVendorApi(
      signUpFormData.vdcpCd,
      signUpFormData.soprMgrCopCd,
      signUpFormData.dmstFrgDivsCd
    ).then((res) => {
      if (res.successOrNot === 'Y') {
        if (res.data.sapValidYn == 'N') {
          const copCd = signUpFormData.soprMgrCopCd;
          const vdcpCd = signUpFormData.vdcpCd;
          const soprMgrCopNm = copCdList.find((item) => copCd === item.cmnCd);
          // 이전 메세지 코드 com.label.00717, 변수 생성 위해 신규 코드로 변경
          // i18에서 메세지에 변수 처리 법 t('메세지 코드',{ 변수명: 변수값}) 메세지 작성할 때는 메세지에 변수를 {{변수명}} 으로 해줌
          openMessageBar(
            'warning',
            t('com.label.copCd.emptyVdcpCd', {
              vdcpCd,
              copCd,
              copNm: soprMgrCopNm?.cmnCdNm,
            })
          );
          return true;
        }
        // setSignUpFormData((prev) => {
        //   return { ...signUpFormData, cfrmVdcpCd: true };
        // });
        return false;
      }
      return false;
    });
    return bool;
  }

  async function copyCopCdDupleAccounts() {
    //
    const bankKeyCd = dtlFrgnAccount?.bankKeyCd ?? '';
    const encAccnNo = dtlFrgnAccount?.encAccnNo ?? '';
    const currCd = dtlFrgnAccount?.currCd ?? '';
    const soprMgrCopCd = signUpFormData.soprMgrCopCd ?? '';
    const copyCopCdAccounts =
      (await getDupleCopyForeignAccount(
        props.vendorInfo.vdcpCd,
        bankKeyCd,
        encAccnNo,
        currCd,
        soprMgrCopCd
      )) ?? [];
    const soprMgrCopNm = copCdList.filter((item) => soprMgrCopCd === item.cmnCd);

    let accnRegProgStatCdNm = '';

    if (copyCopCdAccounts.length > 0) {
      const progStatCd = copyCopCdAccounts[0]?.accnRegProgStatCd;
      for (const v of statCdList) {
        if (v.cmnCd === progStatCd) {
          accnRegProgStatCdNm = v.cmnCdNm ?? '';
        }
      }
      //  content: `[${soprMgrCopNm[0].cmnCdNm}]법인에 ${accnRegProgStatCdNm}인 동일 계좌가 있어 Copy가 불가합니다.`,
      openCommonModal({
        modalType: 'alert',
        content: t('com.label.accCopyDuple', {
          copCdNm: soprMgrCopNm[0].cmnCdNm,
          statNm: accnRegProgStatCdNm,
        }),
      });
      return false;
    }
    return true;
  }

  const handleOnSave = async () => {
    //
    if (!emailValid()) return;
    // 법인 ,담당자 validation
    if (!copyValid()) return;
    if (
      !validFiles(
        [fileDropzoneRef1, fileDropzoneRef2, fileDropzoneRef3], //, fileDropzoneRef4, fileDropzoneRef5
        [
          t('com.label.00453', '__계좌등록요청서'),
          t('com.label.00659', '__은행계좌확인서 또는 계좌사본(인증시)'),
          t('com.label.00284', '__국가별법인등록증'),
        ] //, '기타1', '기타2'
      )
    ) {
      return;
    }

    // 해외 벤더 외화 SWIFT/BIC KR일 경우 계좌 예금주 확인 막기 20241115
    // TODO 예금주 확인
    if (
      chgAccnInfo.dmstFrgDivsCd == 'DO' &&
      props.vendorInfo.soprMgrCopCd == 'HQ00' &&
      chgAccnInfo.bankLoctCtryCd == 'KR'
    ) {
      if (chgAccnInfo.isDpstNmCert == 'Y') {
        if (chgAccnInfo.isDpstNmCertRslt != 'Y') {
          openCommonModal({
            modalType: 'alert',
            content: t('com.label.00727', '__계좌를 인증해주세요'),
          });
          return;
        }
      }
    }
    // 요구사항 6번
    if (!chkEnInput()) return;
    // VendorID 인증 (SAP_IF)
    const schema = props.isKrw ? regSchemaKrw : dmstFrgDivsCd == 'DO' ? regSchemaDo : regSchema;

    schema
      .validate(chgAccnInfo)
      .then(async () => {
        // 2차 검수 피드백 : 저장노티 띄우지 않고 바로 '저장되었습니다' 메세지 노출
        // 수정자 : 양지원
        try {
          openLoading(true);

          const bool = await modifyCheckVendor();

          if (bool) return;

          const dupleAccount = await copyCopCdDupleAccounts();

          if (!dupleAccount) return;

          await getAccountFileIds();
          const param = {
            ...chgAccnInfo,
            soprMgrCopCd: signUpFormData.soprMgrCopCd,
            soprMgrNm: signUpFormData.soprMgrNm,
            soprMgrEmal: signUpFormData.soprMgrEmal,
            soprMgrPhn: signUpFormData.soprMgrPhn,
            soprMgrEmpNo: signUpFormData.soprMgrEmpNo,
            wktDivsCd: 'N', // 신규로만 들어가도록 고정 시킴
          };
          await copyForeignAccount(param, files, dtlFrgnAccount).then((resp) => {
            if (resp.successOrNot === 'Y') {
              openMessageBar('success', t('com.msg.save', '__저장되었습니다.'));
              props.save(true);
              setIsCopyAccount();
            }
          });
        } catch (e) {
          console.log('e', e);
          openCommonModal({
            modalType: 'alert',
            content: 'Copy Fail',
          });
          return;
        } finally {
          openLoading(false);
        }
      })
      .catch((e) => {
        console.log('error : ', e);
        openCommonModal({
          modalType: 'alert',
          content: e.message,
        });
        return;
      });
  };

  /**
   * 첨부파일 필수여부 체크
   */
  const validFiles = (arrRef, arrMsg) => {
    //
    let flag = true;
    //
    for (let index = 0; index < arrRef.length; index++) {
      const o = arrRef[index];
      // 상세에서 넘어온 첨부파일 없는 경우만  validation 적용 되도록(단 계좌 등록 요청서만 제외)
      if (dtlFrgnAccount && !_.isEmpty(dtlFrgnAccount[`fileId${index + 1}`])) break;
      if (!o.current.getFiles().filter((o) => o.useYn == 'Y').length) {
        flag = false;
        openCommonModal({
          modalType: 'alert',
          content: `${arrMsg[index]} ${t('com.label.00454', '__첨부파일을 추가하세요')}`,
        });
        break;
      }
    }
    return flag;
  };

  const getFileId = useCallback(async (dropzoneRef) => {
    const fileSaveResponse: FileSaveResponse = await dropzoneRef.current.saveFiles();
    return fileSaveResponse.fileSaveResult == FileSaveResult.FAIL
      ? null
      : fileSaveResponse.atchFileGrId;
  }, []);

  const getAccountFileIds = async () => {
    // _.isEmpty(dtlFrgnAccount?.fileId1)
    if (_.isEmpty(dtlFrgnAccount?.fileId1) && fileDropzoneRef1.current.getFiles().length) {
      await getFileId(fileDropzoneRef1).then((respFileId) => {
        if (respFileId) {
          files.fileId1 = respFileId;
          setChgAccnInfo((prev) => {
            return { ...prev, fileId1: respFileId };
          });
        }
      });
    }
    if (_.isEmpty(dtlFrgnAccount?.fileId2) && fileDropzoneRef2.current.getFiles().length) {
      await getFileId(fileDropzoneRef2).then((respFileId) => {
        if (respFileId) {
          files.fileId2 = respFileId;
          setChgAccnInfo((prev) => {
            return { ...prev, fileId2: respFileId };
          });
        }
      });
    }
    if (_.isEmpty(dtlFrgnAccount?.fileId3) && fileDropzoneRef3.current.getFiles().length) {
      await getFileId(fileDropzoneRef3).then((respFileId) => {
        if (respFileId) {
          files.fileId3 = respFileId;
          setChgAccnInfo((prev) => {
            return { ...prev, fileId3: respFileId };
          });
        }
      });
    }

    if (_.isEmpty(dtlFrgnAccount?.fileId5) && fileDropzoneRef5.current.getFiles().length) {
      await getFileId(fileDropzoneRef5).then((respFileId) => {
        if (respFileId) {
          files.fileId5 = respFileId;
          setChgAccnInfo((prev) => {
            return { ...prev, fileId5: respFileId };
          });
        }
      });
    }
  };

  const emailValid = () => {
    // 이메일 형식
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(?:\.[a-zA-Z]{2,})?$/;
    const emails = [chgAccnInfo.bankEml];

    const invalidEmails = emails.filter((email) => email && !emailRegex.test(email));
    if (invalidEmails.length > 0) {
      openMessageBar('warning', t('com.label.00230', '__이메일 형식이 올바르지 않습니다.'));
      return false;
    }
    return true;
  };

  /**
   * copy시 담당 법인, 담당자 validation
   */
  function copyValid(): boolean {
    //
    if (_.isEmpty(signUpFormData.soprMgrCopCd)) {
      openCommonModal({
        modalType: 'alert',
        content: t('com.label.mgt.required.soprMgrCopCd', '__법인명을 선택하세요'),
      });
      return false;
    }
    console.log('signUpFormData', signUpFormData);
    if (_.isEmpty(signUpFormData.soprMgrNm) || _.isEmpty(signUpFormData.soprMgrEmal)) {
      openCommonModal({
        modalType: 'alert',
        content: t('com.label.00508', '__담당자 필수 입력 항목입니다.'),
      });
      return false;
    }
    return true;
  }

  useEffect(() => {
    console.log('props.frgnAccount.accnRegReqId', props.frgnAccount.accnRegReqId);
    (async () => {
      openLoading(true);
      // 공통코드 조회 (계좌추가정보)
      await getJwtCommonCodes('BANK_NO_TP_CD')
        .then((resp) => {
          openLoading(false);
          setBankNoTpCdList(resp);

          if (props.isKrw) {
            setChgAccnInfo((prev) => {
              return { ...prev, bankNoTpCd: '9' };
            });
          }
        })
        .catch((e) => {
          openLoading(false);
        });

      // 공통코드 조회 (국가키)
      await getJwtCommonCodes('BANK_LOCT_CTRY_CD')
        .then((resp) => {
          openLoading(false);
          setBankLoctCtryCdList(resp);
          if (props.isKrw) {
            setChgAccnInfo((prev) => {
              return { ...prev, bankLoctCtryCd: 'KR', bankCtryCd: 'KR' };
            });
          }
        })
        .catch((e) => {
          openLoading(false);
        });

      await getJwtCommonCodes('COP_CD')
        .then((resp) => {
          openLoading(false);
          // 카피하려는 법인은 법인 콤보 박스 목록에서 제거
          const retval = resp.filter((item) => item.cmnCd !== props.vendorInfo.soprMgrCopCd);
          console.log('법인', retval);
          setCopCdList(retval);
        })
        .catch((e) => {
          openLoading(false);
        });

      if (props.frgnAccount.accnRegReqId) {
        // db에 데이터가 있는 경우
        openLoading(true);
        getForeignAccount(props.frgnAccount.vdcpCd, props.frgnAccount.accnRegReqId)
          .then((resp) => {
            openLoading(false);
            if (resp) {
              // 계좌등록요청서 첨부파일 초기화
              // setDtlFrgnAccount({ ...resp });
              setDtlFrgnAccount({ ...resp, fileId1: '' });
              setChgAccnInfo((prev) => {
                return {
                  ...prev,
                  ...resp,
                  bankKeyCd: '', //뱅크키 초기화
                  bankCd: '', //0404 수정
                  addAtrValCtn06: 'N',
                  isDpstNmCertRslt: 'N',
                  trnmDtm: '',
                  trnmYn: '',
                };
              });
              // 계좌등록요청서 첨부파일 등록하라는 메세지 팝업 호출 추가
              // openCommonModal({
              //   modalType: 'alert',
              //   content: `${t('com.label.00453', '__계좌등록요청서')} ${t(
              //     'com.label.00454',
              //     '__첨부파일을 추가하세요'
              //   )}`,
              // });
            }
          })
          .catch((e) => {
            openLoading(false);
          });
      } else {
        //TODO db에 데이터가 없는 경우
        setDtlFrgnAccount({
          ...props.frgnAccount,
          txCd: props.vendorInfo.copRegNo,
          currCd: props.isKrw ? 'KRW' : props.frgnAccount.currCd ?? 'USD',
          // aprRqrEmpNo: 'FP501318',
        });
        setChgAccnInfo((prev) => {
          return {
            ...prev,
            ...props.frgnAccount,
            currCd: props.isKrw ? 'KRW' : props.frgnAccount.currCd ?? 'USD',
            txCd: props.vendorInfo.copRegNo,
            bankLoctCtryCd: props.frgnAccount.bankLoctCtryCd,
            bankKeyCd: '', //뱅크키 초기화
            bankCd: '', //0404 수정
            addAtrValCtn06: 'N',
            isDpstNmCertRslt: 'N',
          };
        });
        // 모달 호출 국내 계정 해외 계정에 따라 다르게
        if (dmstFrgDivsCd == 'OV' && !props.isKrw) {
          openCommonModal({
            modalType: 'alert',
            content: t(
              'com.label.copyAcc.ov.emptyAccnRegReqId',
              '__은행주소, 은행 전화, 은행 메일, 계좌추가정보을 작성하고 첨부파일을 추가해주셔야 합니다.'
            ),
          });
        } else {
          openCommonModal({
            modalType: 'alert',
            content: t(
              'com.label.copyAcc.emptyAccnRegReqId',
              '__은행주소, 은행 전화, 은행 메일을 작성하고 첨부파일을 추가해주셔야 합니다.'
            ),
          });
        }
      }

      const tmpWktDivsCdList = [
        { cmnCdNm: t('com.code.WKT_DIVS_CD.N', '__New'), cmnCd: 'N' },
        { cmnCdNm: t('com.code.WKT_DIVS_CD.A', '__Addition'), cmnCd: 'A' },
      ];

      setWktDivsCdList(tmpWktDivsCdList);
    })();

    //
    getExceptCopCdData();
  }, []);

  useEffect(() => {
    if (certFlag) {
      setChgAccnInfo((prev) => {
        return {
          ...prev,
          accnNoCertYn: 'Y', // 계좌인증여부
        };
      });
    }
  }, [certFlag]);

  useEffect(() => {
    if (chgAccnInfo.bankCd) {
      setChgAccnInfo((prev) => {
        return {
          ...prev,
          isDpstNmCert: 'Y', // 계좌인증
        };
      });
    } else {
      setChgAccnInfo((prev) => {
        return {
          ...prev,
          isDpstNmCert: props.isKrw ? 'Y' : 'N', // 계좌인증
        };
      });
    }
  }, [chgAccnInfo.bankCd]);

  function callEmptySoprMgrCopCdAlert(bool: boolean) {
    if (!bool) {
      openMessageBar('warning', t('com.label.mgt.required.soprMgrCopCd', '__법인명을 선택하세요'));
    }
  }

  /**
   * 인풋 컴포넌트 체인지 이벤트
   * @param e
   */
  const handleChangeForChgAccn = (e) => {
    //
    const specialChars = ['!', '@', '#', '$', '%', '^', '&', '*', '/', '[', ']', '{', '}', '，'];
    // 예금주 대문자 변환 0319
    if (e.target.id == 'dpstNm') {
      e.target.value = e.target.value.replace(/[äöüßÄÖÜㄱ-ㅎㅏ-ㅣ가-힣]/g, ''); //한글 입력 방지
      // e.target.value = e.target.value.replace(/[^\x00-\x7F\u4E00-\u9FA5]+/g, ''); //한글 입력 방지, 중문 입력가능

      const replacedString = e.target.value.replace(
        new RegExp(`[${specialChars.join('\\')}]`, 'g'),
        ''
      );
      e.target.value = replacedString;

      e.target.value = e.target.value.replace(/[a-z]/g, (match) => {
        return match.toUpperCase();
      });

      setChgAccnInfo((prev) => {
        return {
          ...prev,
          addAtrValCtn06: 'N',
          isDpstNmCertRslt: 'N',
        };
      });
    }

    // 국내 외화 계좌 은행명
    if (dmstFrgDivsCd == 'DO') {
      if (e.target.id == 'bankNm') {
        e.target.value = e.target.value.replace(/[äöüßÄÖÜ\uFF08\uFF09]/g, '');
        setChgAccnInfo((prev) => {
          return {
            ...prev,
            addAtrValCtn06: 'N',
            isDpstNmCertRslt: 'N',
          };
        });
      }
    }

    if (dmstFrgDivsCd == 'OV') {
      if (e.target.id == 'bankNm') {
        e.target.value = e.target.value.replace(
          /[äöüßÄÖÜㄱ-ㅎㅏ-ㅣ가-힣!#$%^&*()=+{}[\]:;"'<>,?/\\|`~\uFF08\uFF09]/g,
          ''
        );
        setChgAccnInfo((prev) => {
          return {
            ...prev,
            addAtrValCtn06: 'N',
            isDpstNmCertRslt: 'N',
          };
        });
      }
      if (e.target.id == 'bankAddr') {
        e.target.value = e.target.value.replace(
          /[äöüßÄÖÜㄱ-ㅎㅏ-ㅣ가-힣!#$%^&*()=+{}[\]:;"'<>,?/\\|`~\uFF08\uFF09]/g,
          ''
        );
        setChgAccnInfo((prev) => {
          return {
            ...prev,
            addAtrValCtn06: 'N',
            isDpstNmCertRslt: 'N',
          };
        });
      }

      if (e.target.id == 'bankEml') {
        // 한글과 특정 특수문자를 제거하는 정규식
        e.target.value = e.target.value.replace(
          /[äöüßÄÖÜㄱ-ㅎㅏ-ㅣ가-힣!#$%^&*()=+{}[\]:;"'<>,?/\\|`~]/g,
          ''
        );

        setChgAccnInfo((prev) => {
          return {
            ...prev,
            addAtrValCtn06: 'N',
            isDpstNmCertRslt: 'N',
          };
        });
      }

      if (e.target.id == 'usePurpCtn') {
        // 등록과 방지 정규식이 다름
        /**
         개선 프로젝트 중 등록 모달과 수정 모달의 계좌용도 정규식 적용이 달라서 등록의 정규식 수정 모달에 적용
         */
        // e.target.value = e.target.value.replace(/[äöüßÄÖÜㄱ-ㅎㅏ-ㅣ가-힣]/g, ''); //한글 입력 방지
        e.target.value = e.target.value.replace(
          /[äöüßÄÖÜㄱ-ㅎㅏ-ㅣ가-힣!#$%^&*()=+{}[\]:;"'<>,?/\\|`~]/g,
          ''
        );

        setChgAccnInfo((prev) => {
          return {
            ...prev,
            addAtrValCtn06: 'N',
            isDpstNmCertRslt: 'N',
          };
        });
      }
    }

    if (e.target.id == 'encAccnNo') {
      e.target.value = e.target.value.replace(/[^a-zA-Z0-9]/g, '');
      e.target.value = e.target.value.replace(/[a-z]/g, (match) => {
        return match.toUpperCase();
      });
      setChgAccnInfo((prev) => {
        return {
          ...prev,
          addAtrValCtn06: 'N',
          isDpstNmCertRslt: 'N',
        };
      });
    }

    if (e.target.id == 'ibanCd') {
      e.target.value = e.target.value.replace(/[^a-zA-Z0-9]/g, '');
      e.target.value = e.target.value.replace(/[a-z]/g, (match) => {
        return match.toUpperCase();
      });
      setChgAccnInfo((prev) => {
        return {
          ...prev,
          addAtrValCtn06: 'N',
          isDpstNmCertRslt: 'N',
        };
      });
    }

    if (e.target.id == 'swftCd') {
      e.target.value = e.target.value.replace(/[^a-zA-Z0-9]/g, '');
      e.target.value = e.target.value.replace(/[a-z]/g, (match) => {
        return match.toUpperCase();
      });
      const tmpVal = e.target.value;
      if (tmpVal.length >= 6) {
        const tmpBankLoctCtryCd = tmpVal.substring(4, 6);
        if (bankLoctCtryCdList.some((o) => o.cmnCd == tmpBankLoctCtryCd)) {
          setChgAccnInfo((prev) => {
            return {
              ...prev,
              bankLoctCtryCd: tmpBankLoctCtryCd,
              bankCtryCd: tmpBankLoctCtryCd,
              addAtrValCtn06: 'N',
              isDpstNmCertRslt: 'N',
            };
          });
        }
      }
    }

    if (e.target.id == 'bankCtpl') {
      e.target.value = e.target.value.replace(/[^\d]/g, '');
    }

    setChgAccnInfo((prev) => {
      return { ...prev, [e.target.id]: e.target.value };
    });
  };

  /**
   * 계좌 추가정보
   * @param e
   */
  const handleChangeBankNoTpCd = (e) => {
    setChgAccnInfo((prev) => {
      return {
        ...prev,
        bankNoTpCd: e.target.value,
        bankNo: e.target.value == '9' || e.target.value == '' ? '' : prev.bankNo,
      };
    });
  };

  const handleChangeCopCd = (e) => {
    //
    const initSoprMgr = { soprMgrNm: '', soprMgrEmal: '', soprMgrEmpNo: '' };
    setSignUpFormData((prev) => {
      return {
        ...prev,
        soprMgrCopCd: e.target.value,
        ...initSoprMgr,
      };
    });
    setSelectedManagerData([]);
  };

  return (
    <>
      <ModalLayout open={props.open} onClose={handleClose} mMinWidth={1000} mMaxWidth={1000}>
        {dtlFrgnAccount && (
          <>
            <DialogTitleItem onClose={handleClose}>
              <GPopupTitle title2={t('com.label.copyAcc', '__계좌정보복사')} />
            </DialogTitleItem>
            <DialogContent className="popupContent">
              <GridBox>
                <GridItem>
                  <SubTitleBtnArea>
                    <SubTitleBox
                      showSubTitle={true}
                      content={t('com.label.00456', '__계좌상세정보')}
                    />
                  </SubTitleBtnArea>
                  {!props.isKrw && (
                    <GbasicTableWrap style={{ marginBottom: '12px' }}>
                      <GbasicTable>
                        <colgroup>
                          <col style={{ width: '120px' }} />
                          <col style={{ width: 'auto' }} />
                          <col style={{ width: '120px' }} />
                          <col style={{ width: 'auto' }} />
                        </colgroup>
                        <tbody>
                          <>
                            <tr>
                              <th>
                                <GLabelAtomVars
                                  align="left"
                                  isInfo={true}
                                  pTxt={
                                    t(
                                      'com.tooltip.accn.fcur.reg05',
                                      '__ㆍ New: When you are registering a new bank account.\r\nㆍ Addition: If you already have an account registered in the same currency and you want to add another account.'
                                    ) ?? ''
                                  }
                                  pPlace="3"
                                >
                                  {t('com.code.reqClsf', '__요청구분')}
                                </GLabelAtomVars>
                              </th>
                              <td>
                                <GCodeSelect
                                  id={'cmnCd'}
                                  labelKey={'cmnCdNm'}
                                  listData={wktDivsCdList}
                                  onlyShowName={true}
                                  // value={chgAccnInfo.wktDivsCd ?? 'N'}
                                  value={'N'}
                                  width="150px"
                                  readonly
                                />
                              </td>
                              <th>
                                <GLabelAtom align="left" isRequired={true}>
                                  {t('com.label.00610', '__법인명')}
                                </GLabelAtom>
                              </th>
                              <td>
                                <ValidationBox>
                                  <GCodeSelect
                                    id={'cmnCd'}
                                    labelKey={'cmnCdNm'}
                                    listData={copCdList}
                                    onlyShowName={true}
                                    value={signUpFormData.soprMgrCopCd}
                                    onChange={handleChangeCopCd}
                                    width="300px"
                                    emptyLabel={t('com.label.00023', '__선택') as string}
                                  />
                                </ValidationBox>
                              </td>
                            </tr>
                          </>
                        </tbody>
                      </GbasicTable>
                    </GbasicTableWrap>
                  )}
                  <GbasicTableWrap>
                    <GbasicTable>
                      <tbody>
                        {dmstFrgDivsCd == 'OV' && !props.isKrw && (
                          <tr>
                            <th>
                              <GLabelAtom align="left">
                                {t('com.code.accnTp', '__계좌유형')}
                              </GLabelAtom>
                            </th>
                            <td>{chgAccnInfo?.ibanCd}</td>
                          </tr>
                        )}
                        <tr>
                          <th>
                            <GLabelAtom align="left" isRequired>
                              {t('com.label.00067', '__예금주')}
                            </GLabelAtom>
                          </th>
                          <td>
                            <InputField
                              id="dpstNm"
                              status="readonly"
                              align="left"
                              width="100%"
                              value={chgAccnInfo.dpstNm}
                              maxLength={120}
                              readOnly
                            />
                          </td>
                          <th>
                            <GLabelAtom align="left">
                              {t('com.label.00069', '__예금주 확인')}
                            </GLabelAtom>
                          </th>
                          <td>
                            <InputField
                              id="addDpstNm"
                              status="readonly"
                              readOnly
                              align="left"
                              width="100%"
                              value={chgAccnInfo.addDpstNm}
                              maxLength={30}
                            />
                          </td>
                        </tr>

                        <tr>
                          <th>
                            <GLabelAtom align="left" isRequired={chgAccnInfo.ibanYn == 'Normal'}>
                              {t('com.label.00070', '__계좌번호')}
                            </GLabelAtom>
                          </th>
                          <td>
                            <ItemAlignWrap>
                              <InputField
                                id="encAccnNo"
                                status="readonly"
                                readOnly
                                align="left"
                                width="100%"
                                value={chgAccnInfo.encAccnNo}
                                placeholder={
                                  chgAccnInfo.ibanYn == 'Normal'
                                    ? t2('com.label.00377', `__'-'없이 입력하세요`)
                                    : ''
                                }
                                maxLength={100}
                              />
                              {chgAccnInfo.dmstFrgDivsCd === 'DO' &&
                                props.vendorInfo.soprMgrCopCd === 'HQ00' &&
                                chgAccnInfo.bankLoctCtryCd === 'KR' &&
                                chgAccnInfo.isDpstNmCert === 'Y' && (
                                  <GButton
                                    txt={t(`com.label.00457`, `__인증요청`)}
                                    sizes="medium"
                                    btnColor="normal"
                                    btnstyled="outline"
                                    hasImg={false}
                                    hasTxt={true}
                                    onClick={() => {
                                      handleValidAccnClick();
                                    }}
                                  />
                                )}
                            </ItemAlignWrap>
                          </td>
                          <th>
                            <GLabelAtom align="left" isRequired>
                              {t('com.label.00076', '__통화')}
                            </GLabelAtom>
                          </th>
                          <td>{chgAccnInfo.currCd}</td>
                        </tr>
                        {dmstFrgDivsCd == 'OV' && !props.isKrw && (
                          <tr>
                            <th>
                              <GLabelAtom align="left" isRequired={chgAccnInfo.ibanYn != 'Normal'}>
                                IBAN CODE
                              </GLabelAtom>
                            </th>
                            <td>
                              <InputField
                                id="ibanCd"
                                status={'readonly'}
                                readOnly
                                align="left"
                                width="100%"
                                value={chgAccnInfo.ibanCd}
                                placeholder={
                                  chgAccnInfo.ibanYn == 'Normal'
                                    ? ''
                                    : t2('com.label.00068', '__입력하세요')
                                }
                                maxLength={34}
                              />
                            </td>
                            <th>
                              <GLabelAtomVars
                                align="left"
                                isInfo={true}
                                pTxt={t2(
                                  'com.tooltip.accn.fcur.reg04',
                                  '__ㆍSelect and enter ABA Routing No.(EFT Routing No.), Sort Code, CNAPS Code'
                                )}
                                pPlace="3"
                                isRequired
                              >
                                {t('com.code.bankAddIfo', '__계좌추가정보')}
                              </GLabelAtomVars>
                            </th>
                            <td>
                              <ItemAlignWrap>
                                <GCodeSelect
                                  id={'cmnCd'}
                                  labelKey={'cmnCdNm'}
                                  listData={bankNoTpCdList}
                                  onlyShowName={true}
                                  emptyLabel={t2('com.label.00356', '__선택')}
                                  value={chgAccnInfo.bankNoTpCd}
                                  width="108px"
                                  onChange={handleChangeBankNoTpCd}
                                  disabled={!_.isEmpty(dtlFrgnAccount.bankNoTpCd)}
                                />
                                <InputField
                                  id="bankNo"
                                  status={
                                    chgAccnInfo.bankNoTpCd === '9' ||
                                    _.isEmpty(chgAccnInfo.bankNoTpCd)
                                      ? 'readonly'
                                      : 'default'
                                  }
                                  align="left"
                                  width="100%"
                                  value={chgAccnInfo.bankNo}
                                  maxLength={15}
                                  readOnly={
                                    chgAccnInfo.bankNoTpCd === '9' ||
                                    _.isEmpty(chgAccnInfo.bankNoTpCd)
                                  }
                                  onChange={handleChangeForChgAccn}
                                />
                              </ItemAlignWrap>
                            </td>
                          </tr>
                        )}

                        <tr>
                          <th>
                            <GLabelAtom align="left" isRequired={true}>
                              {t('com.label.00065', '__은행')}
                            </GLabelAtom>
                          </th>
                          <td>
                            <InputField
                              id="bankNm"
                              status="readonly"
                              align="left"
                              width="100%"
                              value={chgAccnInfo.bankNm}
                              maxLength={100}
                              readOnly
                            />
                          </td>
                          <th>
                            <GLabelAtom
                              align="left"
                              isRequired={props.isKrw || chgAccnInfo.dmstFrgDivsCd == 'DO'}
                            >
                              SWIFT/BIC
                            </GLabelAtom>
                          </th>
                          <td>
                            <InputField
                              id="swftCd"
                              status="readonly"
                              align="left"
                              width="100%"
                              value={chgAccnInfo.swftCd}
                              maxLength={15}
                              readOnly
                            />
                          </td>
                        </tr>
                        <tr>
                          <th>
                            <GLabelAtom align="left" isRequired>
                              {t('com.code.bankCtry', '__은행소재국가')}
                            </GLabelAtom>
                          </th>
                          <td>
                            <GCodeSelect
                              id={'cmnCd'}
                              labelKey={'cmnCdNm'}
                              listData={bankLoctCtryCdList}
                              emptyLabel={t2('com.label.00356', '__선택')}
                              onlyShowName={true}
                              value={chgAccnInfo.bankLoctCtryCd}
                              width="150px"
                              readonly
                            />
                          </td>
                          <th>
                            <GLabelAtom align="left" isRequired>
                              {t('com.code.bankAddr', '__은행주소')}
                            </GLabelAtom>
                          </th>
                          <td>
                            <InputField
                              id="bankAddr"
                              status={dtlFrgnAccount.bankAddr ? 'readonly' : 'default'}
                              align="left"
                              width="100%"
                              value={chgAccnInfo.bankAddr}
                              maxLength={200}
                              onChange={handleChangeForChgAccn}
                              readOnly={!!dtlFrgnAccount.bankAddr}
                            />
                          </td>
                        </tr>
                        <tr>
                          <th>
                            <GLabelAtom align="left" isRequired>
                              {t('com.code.bankCntNum', '__은행연락처')}
                            </GLabelAtom>
                          </th>
                          <td>
                            <InputField
                              id="bankCtpl"
                              status={dtlFrgnAccount.bankCtpl ? 'readonly' : 'default'}
                              align="left"
                              width="100%"
                              value={chgAccnInfo.bankCtpl}
                              maxLength={15}
                              onChange={handleChangeForChgAccn}
                              readOnly={!!dtlFrgnAccount.bankCtpl}
                            />
                          </td>
                          <th>
                            <GLabelAtom align="left" isRequired>
                              {t2('com.code.bankEmal', '__은행이메일')}
                            </GLabelAtom>
                          </th>
                          <td>
                            <InputField
                              id="bankEml"
                              status={dtlFrgnAccount.bankEml ? 'readonly' : 'default'}
                              align="left"
                              width="100%"
                              value={chgAccnInfo.bankEml}
                              maxLength={50}
                              onChange={handleChangeForChgAccn}
                              readOnly={!!dtlFrgnAccount.bankEml}
                            />
                          </td>
                        </tr>
                        <tr>
                          <th>
                            <GLabelAtom align="left">
                              {t('com.label.00071', '__계좌용도')}
                            </GLabelAtom>
                          </th>
                          <td colSpan={3}>
                            <InputField
                              id="usePurpCtn"
                              status={dtlFrgnAccount.usePurpCtn ? 'readonly' : 'default'}
                              align="left"
                              width="100%"
                              value={chgAccnInfo.usePurpCtn}
                              // placeholder={t2('com.label.00068', '__입력하세요')}
                              maxLength={25}
                              onChange={handleChangeForChgAccn}
                              readOnly={!!dtlFrgnAccount.usePurpCtn}
                            />
                          </td>
                        </tr>
                        <tr>
                          <th>
                            <GLabelAtom align="left" isRequired={true}>
                              {t('com.label.00095', '__담당자')}
                            </GLabelAtom>
                          </th>
                          <td>
                            <ValidationBox>
                              <VarsAutoInput
                                id="signup"
                                width="350px"
                                openModal={managerSrchModalOpen}
                                setOpenModal={setManagerSrchModalOpen}
                                signUpFormData={signUpFormData}
                                setSignUpFormData={setSignUpFormData}
                                selectedManagerData={selectedManagerData}
                                setSelectedManagerData={setSelectedManagerData}
                                onClick={() => {
                                  const bool = !_.isEmpty(signUpFormData.soprMgrCopCd);
                                  setManagerSrchModalOpen(bool);
                                  callEmptySoprMgrCopCdAlert(bool);
                                }}
                                coCdList={copCdList}
                              />
                            </ValidationBox>
                          </td>
                        </tr>
                      </tbody>
                    </GbasicTable>
                  </GbasicTableWrap>
                  <GbasicTableWrap style={{ marginTop: '12px' }}>
                    <GbasicTable>
                      <tbody>
                        <tr>
                          <th>
                            <GLabelAtomVars
                              align="left"
                              isRequired
                              isInfo={true}
                              pTxt={
                                t(
                                  'com.tooltip.accn.fcur.reg01',
                                  '__ㆍ상단 "Payment Information Form 출력"을 클릭하여 Payment Information Form에 기재된 내용의 이상 여부 확인\r\nㆍ기재된 내용에 이상이 없는 경우 서류를 출력하여 법인인감 날인(한국 소재 기업) 또는 서명하여 첨부하세요.'
                                ) ?? ''
                              }
                              pPlace="3"
                            >
                              {t('com.label.00453', '__계좌등록요청서')}
                            </GLabelAtomVars>
                          </th>
                          <td colSpan={3}>
                            {_.isEmpty(dtlFrgnAccount?.fileId1) ? (
                              <FileUploadVars
                                ref={fileDropzoneRef1}
                                atchFileGrIdInput={dtlFrgnAccount?.fileId1 ?? ''}
                                isMultipleFile={false}
                                maxCount={1}
                                allowFileTypes={['jpg', 'png', 'pdf']}
                                height="40px"
                                width="100%"
                                getSelectedFile={(value) => {
                                  if (value.length == 0) {
                                    files.fileId1 = '';
                                  }
                                }}
                              />
                            ) : (
                              <FileDownloadVars atchFileGrId={dtlFrgnAccount.fileId1} />
                            )}
                          </td>
                        </tr>
                        <tr>
                          <th rowSpan={2}>
                            <GLabelAtomVars
                              align="left"
                              isRequired
                              isInfo={true}
                              pTxt={
                                t(
                                  'com.tooltip.accn.fcur.reg02',
                                  '__은행으로부터 발급받은 은행계좌확인서\r\nㆍ 은행담당자 서명 필수\r\nㆍ 한국 소재 기업인 경우 통장 사본 함께 첨부'
                                ) ?? ''
                              }
                              pPlace="3"
                            >
                              {t('com.label.00659', '__은행계좌확인서 또는 계좌사본(인증시)')}
                            </GLabelAtomVars>
                          </th>
                          <td>
                            <GButton
                              txt={t('com.code.smpDown', '__샘플 다운로드')}
                              chkImg={Download}
                              btnstyled="outline"
                              btnColor="normal"
                              sizes="small"
                              hasTxt={true}
                              hasImg={true}
                              disabled={!_.isEmpty(dtlFrgnAccount?.fileId2)}
                              onClick={() => {
                                const url = '/assets/file/AccountComfirmationSample.pdf';
                                const link = document.createElement('a');
                                link.href = url;
                                link.setAttribute('download', 'AccountComfirmationSample.pdf');
                                document.body.appendChild(link);
                                link.click();
                                document.body.removeChild(link);
                                URL.revokeObjectURL(url);
                              }}
                            />
                          </td>
                        </tr>
                        <tr>
                          <td colSpan={3}>
                            {_.isEmpty(dtlFrgnAccount?.fileId2) ? (
                              <FileUploadVars
                                ref={fileDropzoneRef2}
                                atchFileGrIdInput={dtlFrgnAccount?.fileId2 ?? ''}
                                isMultipleFile={false}
                                maxCount={1}
                                allowFileTypes={['jpg', 'png', 'pdf']}
                                height="40px"
                                width="100%"
                                getSelectedFile={(value) => {
                                  if (value.length == 0) {
                                    files.fileId2 = '';
                                  }
                                }}
                              />
                            ) : (
                              <FileDownloadVars atchFileGrId={dtlFrgnAccount.fileId2} />
                            )}
                          </td>
                        </tr>
                        <tr>
                          <th rowSpan={2}>
                            <GLabelAtomVars
                              align="left"
                              isRequired
                              isInfo={true}
                              pTxt={
                                t(
                                  'com.tooltip.accn.fcur.reg03',
                                  '__ㆍ W-9, 사업자등록증 등\r\nㆍ 한국 소재 기업인 경우 3개월 이내 발급한 법인인감증명서 함께 첨부 필수'
                                ) ?? ''
                              }
                              pPlace="3"
                            >
                              {t('com.label.00284', '__국가별법인등록증')}
                            </GLabelAtomVars>
                          </th>
                          <td>
                            <GButton
                              txt={t('com.code.smpDown', '__샘플 다운로드')}
                              chkImg={Download}
                              btnstyled="outline"
                              btnColor="normal"
                              sizes="small"
                              hasTxt={true}
                              hasImg={true}
                              disabled={!_.isEmpty(dtlFrgnAccount?.fileId3)}
                              onClick={() => {
                                const url = '/assets/file/sample.pdf';
                                const link = document.createElement('a');
                                link.href = url;
                                link.setAttribute('download', 'sample.pdf');
                                document.body.appendChild(link);
                                link.click();
                                document.body.removeChild(link);
                                URL.revokeObjectURL(url);
                              }}
                            />
                          </td>
                        </tr>
                        <tr>
                          <td colSpan={3}>
                            {_.isEmpty(dtlFrgnAccount?.fileId3) ? (
                              <FileUploadVars
                                ref={fileDropzoneRef3}
                                atchFileGrIdInput={dtlFrgnAccount?.fileId3 ?? ''}
                                isMultipleFile={false}
                                maxCount={1}
                                allowFileTypes={['jpg', 'png', 'pdf']}
                                height="40px"
                                width="100%"
                                getSelectedFile={(value) => {
                                  if (value.length == 0) {
                                    files.fileId3 = '';
                                  }
                                }}
                              />
                            ) : (
                              <FileDownloadVars atchFileGrId={dtlFrgnAccount.fileId3} />
                            )}
                          </td>
                        </tr>
                        <tr>
                          <th>
                            <GLabelAtomVars align="left">
                              {t('com.label.00075', '__기타')}
                            </GLabelAtomVars>
                          </th>
                          <td colSpan={3}>
                            {_.isEmpty(dtlFrgnAccount?.fileId5) ? (
                              <FileUploadVars
                                ref={fileDropzoneRef5}
                                atchFileGrIdInput={dtlFrgnAccount?.fileId5 ?? ''}
                                isMultipleFile={true}
                                maxCount={5}
                                allowFileTypes={['jpg', 'png', 'xlsx', 'pdf']}
                                height="40px"
                                width="100%"
                                getSelectedFile={(value) => {
                                  if (value.length == 0) {
                                    files.fileId5 = '';
                                  }
                                }}
                              />
                            ) : (
                              <FileDownloadVars atchFileGrId={dtlFrgnAccount.fileId5} />
                            )}
                          </td>
                        </tr>
                      </tbody>
                    </GbasicTable>
                  </GbasicTableWrap>
                </GridItem>
              </GridBox>
            </DialogContent>
            <DialogActions className="popupBottom">
              <GButtonBox>
                <GButton
                  txt={t('com.label.prntPif', '__Payment Information Form 출력')}
                  sizes="medium"
                  btnstyled="outline"
                  btnColor="normal"
                  hasImg={false}
                  hasTxt={true}
                  // chkImg={Delete} 프린터기 이미지 확인필요
                  onClick={handleClickPif}
                ></GButton>
                <GButton
                  txt={t('com.label.00036', '취소')}
                  sizes="medium"
                  onClick={handleClose}
                  btnColor="normal"
                  btnstyled="outline"
                  hasImg={false}
                  hasTxt={true}
                />
                <GButton
                  txt={t('com.label.00055', '저장')}
                  chkImg={Save}
                  sizes="medium"
                  onClick={handleOnSave}
                  btnstyled="contained"
                  btnColor="primary"
                  hasImg={true}
                  hasTxt={true}
                ></GButton>
              </GButtonBox>
            </DialogActions>
          </>
        )}
      </ModalLayout>
    </>
  );
};

const ItemAlignWrap = styled.div`
  display: flex;
  gap: 4px;
`;

export default DmsCopyFrgnAcntModal;
